import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureSelfRegLinkSiteGroupApplied } from '@/lib/bootstrapSiteGroup';
import { isDocumentPrerendering, waitUntilNotPrerendering } from '@/lib/prerender';

/**
 * Route-level re-apply of `/Schedule/?SiteGroup=` branding.
 *
 * DO NOT REMOVE — part of the Chrome omnibox prerender timing fix (see
 * `lib/bootstrapSiteGroup.ts` and `lib/prerender.ts`).
 *
 * After a long wait in the address bar, Chrome activates a prerendered document that
 * has often already Navigated to `/self-reg` with `?SiteGroup=` stripped. Module-load
 * bootstrap alone then misses the link SiteGroup. This component waits until
 * `document.prerendering` is false (and also listens for `prerenderingchange` when
 * location does not change) and calls `ensureSelfRegLinkSiteGroupApplied()`.
 */
export function SiteGroupUrlSync() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      await waitUntilNotPrerendering();
      if (cancelled) return;
      ensureSelfRegLinkSiteGroupApplied();
    };

    void run();

    // Activation with no pathname change (already on /self-reg from prerender divert).
    const onActivate = () => {
      if (cancelled) return;
      ensureSelfRegLinkSiteGroupApplied();
    };
    if (isDocumentPrerendering()) {
      document.addEventListener('prerenderingchange', onActivate, { once: true });
    }

    return () => {
      cancelled = true;
      document.removeEventListener('prerenderingchange', onActivate);
    };
  }, [location.pathname, location.search]);

  return null;
}
